










































































































































































































































































































































































































































































































































































import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Tree, Progress, Table, Form as ElForm } from "element-ui";
import { ruleNormal, rulePattern, hasPermission, digui } from "../../../utils/common";
import {
  getCurrentUserRoleTreeList,
  getRolesById,
  postRoles,
  putRolesById,
  delRolesById,
  getRoleMenuTreeList,
  putRoleMenu,
  getRoleMenu,
  updateRoleMenu,
  getRoleResource,
  putBatchAdds,
  delBatchDel,
  getBaseUserPage,
  putBaseUserRole,
  delBaseUserRole
} from "../../../api/roleManage";

Vue.use(hasPermission);
// 用户角色表单的接口
interface userRoleForm {
  roleName: string | undefined;
  roleCode: string | undefined; // 编码是字符串类型
  rolePath: string | undefined; // 路径
  roleOrder: number | undefined; // 序号要前端特别校验
  // isEnable: boolean | undefined;
  roleLevel: string | undefined; // 角色层级
  isEnable: string | boolean | undefined; // 是否可用
  roleDescription: string | undefined;
  roleId: string | undefined; // 角色的id
  roleParentId: string | undefined; // 修改菜单用到的id，我也不确定哎
}
// 编辑角色菜单的数据
interface userRoleMenu {
  menuName: string | undefined;
  deadlineStartTime: any | null;
  deadlineEndTime: any | null;
  isDeadline: string | null;
  isEnable: string | undefined;
  menuId: string | undefined;
  roleId: string | undefined;
  roleMenuId: string | null;
}

interface searchFormInfo {
  current: number | undefined;
  isChecked: string | undefined;
  userNameOrAccount: string | undefined;
  size: number | undefined;
}
@Component({
  filters: {
    filterEnabled(v) {
      let map = {
        TRUE: "有效",
        FALSE: "失效"
      };
      return map[v];
    },
    filterIsChecked(v) {
      let map = {
        TRUE: "已绑定",
        FALSE: "未绑定"
      };
      return map[v];
    }
  }
})
export default class role extends Vue {
  // 用户角色树的数据
  private userRoleTreeData: Array<object> = [];
  //   默认选中的节点的数组
  private chkedArr: Array<object> = [];
  private defaultProps: Object = {
    children: "childList",
    label: "name"
  };

  // 用户资源表格的规则
  private userRoleFormRules: object = {
    roleName: ruleNormal("请输入菜单名称"),
    roleCode: rulePattern(/^[^\u4e00-\u9fa5]+$/,"仅支持英文和数字"),
    roleLevel: ruleNormal("请选择菜单层级"),
    rolePath: rulePattern(/^[^\u4e00-\u9fa5]+$/,"仅支持英文和数字"),
    roleOrder: rulePattern(/^(|[0-9]+)$/, "请输入整数")
  };
  /*==========用户角色菜单树(右侧)的数据开始============*/

  private roleMenuTree: Array<object> = [];
  private menuDefaultProps: object = {
    children: "childList",
    label: "name"
  };
  private menuChkedArr: Array<any> = []; // 默认选中的节点的数组
  private userMenuId: string = ""; // 全局菜单id的中转
  private menuMenuVisible: boolean = false;
  private roleMenuDialogFormVisible: boolean = false;
  /*==========用户角色菜单树(右侧)的数据结束============*/

  private userMenuVisible: boolean = false; // 右键菜单栏的显示隐藏
  private roleDialogFormVisible: boolean = false; // 右键增改对话框
  private roleFlag: boolean = true; // 角色菜单 roleFlag ？增加角色 ： 修改角色
  private isNotRootMenu: boolean = true; // 默认为true，即显示右键删除子菜单
  private roleChildLength: number = 0;

  private userId: string = ""; //  中转的用户角色 roleId
  private cjglyParentId: string = ""; // 存储超级管理员的父id

  // 菜单弹框新增显示的基本信息
  private userRoleForm: any = {
    roleName: undefined,
    roleCode: undefined, // 编码是字符串类型
    rolePath: undefined,
    roleOrder: undefined,
    roleLevel: undefined, // 角色层级
    isEnable: true,
    roleDescription: undefined,
    roleParentId: 101, // 这个需要改，这个parentid其实是指当前点击的菜单的id
    roleId: undefined // 修改菜单用到的id，我也不确定哎
  };
  private userLevelOptions: Array<object> = [
    {
      value: "grovince",
      label: "省"
    },
    {
      value: "city",
      label: "市"
    },
    {
      value: "area",
      label: "县区"
    },
    {
      value: "place",
      label: "考点"
    },
    {
      value: "district",
      label: "考区"
    },
    {
      value: "school ",
      label: "学校"
    }
  ];

  private userRoleMenuRules: object = {
    deadlineStartTime: [ruleNormal("请选择开始时间")],
    deadlineEndTime: [ruleNormal("请选择结束时间")]
  };
  private filterText: string = ""; // 过滤角色树用的

  public $refs!: {
    validate: HTMLFormElement;
    userRoleTree: HTMLFormElement;
    menutree: HTMLFormElement;
  };
  // 节点筛选
  @Watch("filterText", { deep: true })
  getfilterText(val) {
    (this.$refs.userRoleTree as any).filter(val);
    // 如果有上面的 $refs!声明，就用上面行，如果没有，就用下面这两行
    // const tree = <Tree>this.$refs.userRoleTree;
    // tree.filter(val);
  }
  private filterNode(value, userRoleTreeData) {
    if (!value) return true;
    return userRoleTreeData.name.indexOf(value) !== -1;
  }
  // 编辑角色菜单的数据
  private userRoleMenuForm: userRoleMenu = {
    deadlineEndTime: null,
    deadlineStartTime: null,
    isDeadline: "TRUE",
    isEnable: undefined,
    menuName: "",
    menuId: undefined, // 菜单id
    roleId: undefined, // 角色id
    roleMenuId: null // 角色菜单id
  };

  // 编辑角色资源的数据
  private userResourceDialog: boolean = false;
  private userResourceTable: Array<object> = []; // 用户资源数据
  private userResSelectionId: Array<string> = []; // 表格选中时的id数组
  /*---------角色节点点击的方法----------*/

  // 刷新右边的树
  private async refreshRght() {
    let res = await getRoleMenuTreeList(this.userId);
    // this.menuChkedArr.length = 0; // 避免相互改变
    this.menuChkedArr = []; // 避免相互改变
    // if (res.data[0].childList == null) {
    //   if (res.data[0].isChecked == "TRUE") {
    //     this.menuChkedArr.push(res.data[0].id);
    //   }
    // } else {
    //   res.data[0].childList.forEach((e) => {
    //     e.isChecked == "TRUE" ? this.menuChkedArr.push(e.id) : "";
    //   });
    // }

    // ---- 重写处理后台返回数据的非递归方法 ---- 
    let data  = res.data
    if(data[0].childList == null){
      if(data[0].isChecked == "TRUE"){
        this.menuChkedArr.push(data[0].id);
      }
    } else {
      data[0].childList.forEach( child1 => {
        if(child1.childList == null){
          if(child1.isChecked == "TRUE"){
            this.menuChkedArr.push(child1.id);
          }
        }else{
          child1.childList.forEach(child2 =>{
            if(child2.isChecked == "TRUE"){
            this.menuChkedArr.push(child2.id);
          }
          })
        }
      })
    }

    // ---- 重写处理后台返回数据的非递归方法 ---- 

    this.roleMenuTree = [...res.data];
    
  }
  private async handleNodeClick(event) {
    // 左键点击角色树节点的时候，在右侧角色菜单树种显示对应角色的菜单树
    this.userMenuVisible = false;
    this.userId = event.id; // 方便右侧点击使用
    this.refreshRght();
    this.getTableList();
  }

  // 角色增加 提交
  private async handleSubmit() {
    let flag = false;
    (this.$refs[`userRoleForm`] as ElForm).validate((valid: boolean) => {
      valid && (flag = true);
    });
    if (!flag) return;
    try {
      if (this.roleFlag) {
        // 增加角色
        await postRoles(this.userRoleForm);
      } else {
        // 修改
        await putRolesById(this.userRoleForm);
      }
      this.roleDialogFormVisible = false;
      this.$message({
        type: "success",
        message: this.roleFlag ? "新增成功" : "修改成功"
      });
      this.resetUserRoleForm();
      this.getCurrentUserRoles();
    } catch (error) {
      this.$message.error(error || (this.roleFlag ? "新增失败" : "修改失败"))
    }
  }

  /*---------- 角色对应的菜单 右边那个的事件开始-------------*/

  private async handleMenuNodeClick(event, obj) {
    this.menuMenuVisible = false;
  }
  // 右键增加修改要用到的根据父级id所获取的父级name，这个id用
  private idForParentName: string = "";
  private parentNameForShow: string = "";
  private menuFilterNode(value, data) {
    if (!value) return true;
    return data.label.indexOf(value) !== -1;
  }

  // 编辑角色菜单 
  private async handleRoleMenuSubmit() {
    if(this.userRoleMenuForm.isDeadline == 'TRUE'){
      if (!this.timeValue || this.timeValue.length == 0) {
      this.$message.warning("请选择限期时间!");
      return false;
    }else{
      this.userRoleMenuForm.deadlineStartTime = moment(this.timeValue[0]).format(
      "YYYY-MM-DD HH:mm:ss"
    ) || '';
    this.userRoleMenuForm.deadlineEndTime = moment(this.timeValue[1]).format(
      "YYYY-MM-DD HH:mm:ss"
    ) || '';
    }
    }else{
      this.userRoleMenuForm.deadlineStartTime = ''
      this.userRoleMenuForm.deadlineEndTime = ''
    }
    
    
    this.userRoleMenuForm.menuId = this.userMenuId; // 菜单id
    this.userRoleMenuForm.roleId = this.userId; // 角色id
    // this.userRoleMenuForm.roleMenuId = endTime;     // 角色菜单id 是根据菜单id和角色id调用接口，从后台返回的数据
    try {
      let res = await updateRoleMenu(this.userRoleMenuForm);
      // this.$message.success(res.mesg);
      this.roleMenuDialogFormVisible = false;
    } catch (error) {
      this.$message.error(error);
    }
  }
  private timeValue: Array<object> = [];
  private handleTestTime() {
    let startTime = moment(this.timeValue[0]).format("YYYY-MM-DD HH:mm:ss");
  }
  private pickerOptions: object = {
    disabledDate(time) {
      return time.getTime() < Date.now();
    }
  };
  /**
   * 以下的 pickerOptionsStart pickerOptionsEnd 方法暂时保留，
   */
  private pickerOptionsStart: object = {
    disabledDate: time => {
      let state;
      if (this.userRoleMenuForm.deadlineEndTime !== "") {
        state =
          time.getTime() < Date.now() &&
          time.getTime() >
            new Date(this.userRoleMenuForm.deadlineEndTime).getTime();
      } else {
        state = time.getTime() < Date.now();
      }
      return state;
    }

    // selectableRange:
  }; //开始日期配置

  private pickerOptionsEnd: object = {
    disabledDate: time => {
      return (
        time.getTime() < Date.now() ||
        time.getTime() <
          new Date(this.userRoleMenuForm.deadlineStartTime).getTime()
      );
    }
  }; //结束日期配置

  // 确定
  private userResourceBtn() {
    this.refreshRght(); // 刷新右侧
    this.userResourceDialog = false;
  }

  // 批量解绑
  private async delDelBatchDels() {
    if (this.userResSelectionId.length == 0) {
      this.$message.warning("请先选择要解绑的资源项");
      return false;
    } else {
      let res = await delBatchDel(this.userId, this.userResSelectionId);
      this.$message.success("解绑成功!");
      this.userResetResTable();
    }
  }

  // 批量绑定
  private async putPutBatchAdds() {
    if (this.userResSelectionId.length == 0) {
      this.$message.warning("请先选择要绑定的资源项");
      return false;
    } else {
      let res = await putBatchAdds(this.userId, this.userResSelectionId);
      this.$message.success("绑定成功!");
      this.userResetResTable();
    }
  }

  // 绑定或者解绑之后刷新角色资源的table
  private async userResetResTable() {
    let obj = {
      current: 1,
      menuId: this.userMenuId,
      roleId: this.userId,
      size: 15
    };
    let res = await getRoleResource(obj);
    this.userResourceTable = res.data.records;
  }

  //// 菜单菜单右键菜单的编辑角色资源
  private async editRoleRights() {
    this.menuMenuVisible = false;
    this.userResetResTable();
    this.userResourceDialog = true;
  }

  // 菜单增加按钮的提交事件
  private async handleAddMenuMenu() {
    // const menutree = <Tree>this.$refs.menutree;
    // let res = menutree.getCheckedNodes(false, true);
    let res = (this.$refs.menutree as any).getCheckedNodes(false, true);
    let tempArr = res.map(i => {
      return i.id;
    });
    try {
      await putRoleMenu(this.userId, tempArr);
      this.$message.success("增加菜单成功！");
    } catch {
      this.$message.error("增加菜单失败!");
    }
  }
  /*----------角色对应的菜单的事件结束-------------*/
  //  菜单菜单资源
  private tbSelectionChange(selection) {
    this.userResSelectionId = selection.reduce((arr, curVal) => {
      arr.push(curVal.resourceId);
      return arr;
    }, []);
  }
  //  菜单菜单资源

  //*****************角色用户***********************************
  private userTableData: Array<object> = [];
  private tableLoading: boolean = false;
  private total: number = 0;
  private size: number = 15;
  private current: number = 1;
  private addLoading: boolean = false;
  private operateVisible: boolean = false;
  private dialogResetFlag: boolean = false;
  private delMoreSyscfgLoading: boolean = false; //批量删除loading
  private operateType: string = "ADD";
  private activeName: string = "userMenu";
  private searchForm: searchFormInfo = {
    current: this.current,
    isChecked: undefined,
    userNameOrAccount: undefined,
    size: 10
  };

  private async putPutBaseUserRole() {
    // tableSelectionId
    if (this.tableSelectionId.length == 0) {
      this.$message.warning("请先选择要绑定的资源项");
      return false;
    } else {
      // this.userTableData.forEach(v=>{
      //   v.userId =='存在'?'':this.tableSelectionId
      // })
      await putBaseUserRole(this.userId, this.tableSelectionId);
      this.$message.success("绑定成功!");
      this.getTableList();
    }
  }

  private async delDelBaseUserRole() {
    if (this.tableSelectionId.length == 0) {
      this.$message.warning("请先选择要解绑的资源项");
      return false;
    } else {
      await delBaseUserRole(this.userId, this.tableSelectionId);
      this.$message.success("解绑成功!");
      this.getTableList();
    }
  }

  // 右侧table表格
  private async getTableList() {
    let res = await getBaseUserPage(this.userId, this.searchForm);
    this.userTableData = res.data.records;
    this.current = res.data.current;
    this.total = res.data.total;
    this.size = res.data.size;
  }

  private async handleResetSearch() {
    this.searchForm = {
      current: 1,
      isChecked: undefined,
      userNameOrAccount: undefined,
      size: this.size
    };
    this.getTableList();
  }

  private handleSizeChange(val: number) {
    this.size = val;
    this.searchForm.size = val;
    this.getTableList();
  }

  private handleCurrentChange(val: number) {
    this.current = val;
    this.searchForm.current = val;
    this.getTableList();
  }

  //表格选择操作
  private tableSelectionId: Array<string> = []; //表格选中的数据id集合

  private userTableChange(selection) {
    this.tableSelectionId = selection.reduce((arr, curVal) => {
      arr.push(curVal.userId);
      return arr;
    }, []);
  }

  // 关闭右键菜单的页面大盒子事件
  private closeContextMenu(event) {
    let userMenu = document.querySelector("#userMenu");
    let userMenuMenu = document.querySelector("#userMenuMenu");

    if (userMenu) {
      if (!userMenu.contains(event.target)) {
        this.userMenuVisible = false;
      }
    }
    if (userMenuMenu) {
      if (!userMenuMenu.contains(event.target)) {
        this.menuMenuVisible = false;
      }
    }
  }

  //因为其他写法有bug，所以这个的作用是页面一加载就显示跟菜单的节点树
  private async funUserTreeForMounted() {
    let res = await getCurrentUserRoleTreeList();
    let res1 = await getRoleMenuTreeList(res.data[0].id);
    this.userId = res.data[0].id; // 用于页面加载的角色id
    this.menuChkedArr.length = 0; // 避免相互改变
    if (res1.data[0].childList == null) {
      if (res1.data[0].isChecked == "TRUE") {
        this.menuChkedArr.push(res1.data[0].id);
      }
    } else {
      res1.data[0].childList.forEach(e => {
        e.isChecked == "TRUE" ? this.menuChkedArr.push(e.id) : "";
      });
    }
    this.roleMenuTree = [...res1.data];
  }

  mounted() {
    this.getCurrentUserRoles();
    this.funUserTreeForMounted();
  }

  // 清空角色表单
  private resetUserRoleForm() {
    this.userRoleForm = {
      roleName: undefined,
      roleCode: undefined, // 编码是字符串类型
      rolePath: undefined,
      roleOrder: undefined,
      roleLevel: undefined, // 角色层级
      isEnable: true,
      roleDescription: undefined,
      roleParentId: undefined,
      roleId: undefined // 修改菜单用到的id，我也不确定哎
    };
  }

  // 根据角色id查询角色菜单
  private async getUserRoles() {
    try {
      let res = await getRolesById(this.userId);
      for (let key in res.data) {
        this.userRoleForm[key] = res.data[key];
      }
    } catch (error) {
      this.$message.error(error || "查询失败！")
    }
  }

  //   获取用户角色树的数据
  private async getCurrentUserRoles() {
    try {
      let res = await getCurrentUserRoleTreeList();
      this.userRoleTreeData = res.data;
      // this.$set(this,"userRoleTreeData",res.data);
    } catch (error) {
      this.$message.error(error || "获取用户角色树失败！")
    }
  }

  //改写tree组件开始
  private async treeAppend(data,parent) {
    this.roleDialogFormVisible = true;
    this.roleFlag = true;
    this.userRoleForm = {
      roleName: undefined,
      roleCode: undefined, // 编码是字符串类型
      rolePath: undefined,
      roleOrder: undefined,
      roleLevel: undefined, // 角色层级
      isEnable: true,
      roleDescription: undefined,
      roleParentId: this.userMenuId,
      roleId: undefined // 修改菜单用到的id，我也不确定哎
    };
    this.userRoleForm.roleParentId = data.id;
    // let res = await getRolesById(data.parentId);
    // this.parentNameForShow = res.data.roleName;
    this.parentNameForShow = parent.name // 因为后台有时候上面接口没数据
  }

  private async treeEdit(data) {
    this.roleDialogFormVisible = true;
    this.roleFlag = false;
    let res = await getRolesById(data.parentId);
    this.parentNameForShow = res.data.roleName;
    await this.getUserRoles();
  }

  private async treeDel(data) {
    if (data.parentId == "-1") {
      this.$message.warning("不能删除超级管理员呀");
      this.userMenuVisible = false;
      return false;
    }
    let confirm: boolean = false;
    let roleLenth: number = 0;
    data.childList == null
      ? (roleLenth = 0)
      : (roleLenth = data.childList.length);
    roleLenth > 0
      ? await this.$confirm(
          "此操作将永久删除该菜单及其所有子菜单, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          })
      : await this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          });
    if (!confirm) return;
    try {
      await delRolesById(data.id);
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.getCurrentUserRoles();
    } catch (error) {
      this.$message({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private mouseleave(data) {
    this.$set(data, "dic", false);
  }

  private mouseover(data, $event) {
    this.$set(data, "dic", true);
    this.userId = data.id; // 方便右侧点击使用
    this.userMenuId = data.id;
    this.idForParentName = data.parentId; // name专用id
    $event.target.nextElementSibling.setAttribute("class", "node block");
  }

  // 角色菜单
  private roleMouseleave(data) {
    this.$set(data, "dis", false);
  }

  private roleMouseover(data) {
    this.$set(data, "dis", true);
    this.userMenuId = data.id;
    this.idForParentName = data.parentId; // name专用id
  }

  private async roleMenuEdit(data) {
    this.menuMenuVisible = false;
    let res = await getRoleMenu(this.userMenuId, this.userId);
    let res1 = await getRoleMenu(this.idForParentName, this.userMenuId); // 父级名字展示
    this.parentNameForShow = res1.data.menuName;

    this.userRoleMenuForm = { ...res.data };
    this.timeValue = [];
    res.data.deadlineStartTime
      ? this.timeValue.push(res.data.deadlineStartTime)
      : "";
    res.data.deadlineStartTime
      ? this.timeValue.push(res.data.deadlineEndTime)
      : "";

    this.roleMenuDialogFormVisible = true;
  }

  private roleRightsEdit(data) {
    this.menuMenuVisible = false;
    this.userResetResTable();
    this.userResourceDialog = true;
  }
  //改写tree组件结束
}
